// Debounce helper
// Allows you to call a function only after a series of rapid calls has finished
// Used to optimize events like resize, scroll, etc.

export function debounce<T extends (...args: any[]) => void>(fn: T, wait = 100) {
  let timeout: ReturnType<typeof setTimeout> | null = null;
  return function (this: any, ...args: Parameters<T>) {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn.apply(this, args);
    }, wait);
  };
}
